import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EditableModule } from '@flyfreely-portal-ui/editable';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { NgSelectModule } from '@ng-select/ng-select';
import { ngfModule } from 'angular-file';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TableModule } from 'ngx-easy-table';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { BulkImportDialogue } from './import-dialogue/import-dialogue.component';
import { BulkUploadDialogue } from './upload-dialogue/upload-dialogue.component';
import { ValidationModule } from '@flyfreely-portal-ui/validation';

@NgModule({
    imports: [
        CommonModule,
        TooltipModule,
        SharedUiModule,
        ngfModule,
        TableModule,
        NgxLoadingModule,
        EditableModule,
        FormsModule,
        ValidationModule,
        NgSelectModule,
        PopoverModule,
        AnalyticsModule,
        EnhancedHelpModule
    ],
    declarations: [BulkUploadDialogue, BulkImportDialogue],
    exports: [BulkUploadDialogue, BulkImportDialogue]
})
export class BulkUploadsModule {}
